import cc from "countries-cities";
import queryString from "querystring";
import React, { Component } from "react";
import { connect } from "react-redux";
import { push } from "../../actions/nav-actions";
import { retrieve } from "../../actions/resources-actions";
import {
  getResourceAuthors,
  getResourceOrganizations,
  validateResource,
  deleteResource,
} from "../../api";
import {
  CardBox,
  EmptyState,
  FormInput,
  FormSelect,
  Page,
  SearchWithAction,
  Table,
  DropdownButton,
} from "../../components";
import { Constants } from "../../defaults";
import { testRegex, notify } from "../../utils";
import Loader from "../../components/Loader";

const order_fields = [
  { label: "Score rating", value: "rating" },
  { label: "Upload date", value: "upload_date" },
  { label: "Alphabetic order", value: "alphabetic" },
  { label: "Verified", value: "verified" },
];

class List extends Component {
  constructor(props) {
    super(props);
    this.state = {
      search: "",
      showFilters: false,
      authors: [],
      organizations: [],
      countries: cc.getCountries().map((c) => ({ value: c, label: c })),
      query: {
        sort: "upload_date",
        tags: [],
        organizations: [],
        authors: [],
      },
    };
    this.renderChild = this.renderChild.bind(this);
    this.renderEmpty = this.renderEmpty.bind(this);
    this.request = this.request.bind(this);
    this.renderFilters = this.renderFilters.bind(this);
  }
  async componentDidMount() {
    const authors = await getResourceAuthors(this.props.user.token);
    const organizations = await getResourceOrganizations(this.props.user.token);
    this.setState(
      {
        authors: Array.isArray(authors)
          ? authors.map((o) => ({ value: o, label: o }))
          : [],
        organizations: Array.isArray(organizations)
          ? organizations.map((o) => ({ value: o, label: o }))
          : [],
      },
      this.request
    );
  }
  request() {
    this.props.retrieve(
      this.props.user.token,
      queryString.stringify(this.state.query)
    );
  }
  renderEmpty() {
    return (
      <Loader/>
    );
  }
  renderChild() {
    return [
      { Header: "Article", accessor: "title" },
      { Header: "Author", accessor: "author" },
      {
        Header: "Date",
        id: "cellDate",
        accessor: (d) => new Date(d.created_at).toLocaleDateString(),
      },
      { Header: "Publisher", accessor: "publisher" },
      {
        Header: "Tags",
        id: "cellTags",
        accessor: (d) => (d.tags || []).join(", "),
      },
      {
        Header: "Locations",
        id: "cellLocations",
        accessor: (d) => (d.locations || []).join(", "),
      },
      {
        Header: "Verified/Rating",
        id: "ratingCell",
        accessor: (d) => (d.verified ? "Verified" : d.rating_value),
      },
      {
        Header: "Options",
        accessor: (d) => d,
        className: "no-overflow",
        id: "options",
        Cell: (props) => (
          <DropdownButton icon="mdi mdi-settings" label="Options">
            {this.props.user.is_admin && (
              <DropdownButton.Option
                onClick={() => this.props.push(`/library/${props.value.key}`)}
                icon="mdi mdi-pencil"
                label="Edit"
              />
            )}
            <DropdownButton.Option
              onClick={() =>
                this.props.push(`/library/${props.value.key}/add-to-project`)
              }
              icon="mdi mdi-plus"
              label={
                this.props.user.is_admin
                  ? "Add to Project/Study Case"
                  : "Add to Project"
              }
            />
            <DropdownButton.Option
              onClick={() => {
                let confirm = window.confirm(
                  "Really wants to validate resource " + props.value.key + "?"
                );
                if (confirm) {
                  validateResource(this.props.user.token, props.value.key)
                    .then((resource) =>
                      this.props.retrieve(this.props.user.token)
                    )
                    .catch((err) => notify(err.message));
                }
              }}
              icon="mdi mdi-check"
              label="Validate"
            />
            <DropdownButton.Option
              onClick={() => {
                let confirm = window.confirm(
                  "Really wants to delete resource " + props.value.key + "?"
                );
                if (confirm) {
                  deleteResource(this.props.user.token, props.value.key)
                    .then((resource) =>
                      this.props.retrieve(this.props.user.token)
                    )
                    .catch((err) => notify(err.message));
                }
              }}
              icon="mdi mdi-delete"
              label="Delete"
            />
          </DropdownButton>
        ),
      },
    ];
  }
  renderFilters() {
    let tags = this.state.query.tags;
    let organizations = this.state.query.organizations;
    let authors = this.state.query.authors;
    return (
      <div>
        <div className="row" style={{ marginBottom: 16, marginTop: 16 }}>
          <FormSelect
            className="col-4"
            value={organizations}
            onChange={(options) => {
              let { query } = this.state;
              query.organizations = options ? options.map((o) => o.value) : [];
              this.setState({ query }, this.request);
            }}
            placeholder="Organizations"
            searchable
            multi
            options={this.state.organizations}
          />
          <FormSelect
            onChange={(option) => {
              let { query } = this.state;
              query.location = option ? option.value : "";
              this.setState({ query }, this.request);
            }}
            placeholder="Geografic location"
            searchable
            value={this.state.query.location}
            options={this.state.countries}
            className="col-4"
          />
        </div>
        <div className="row">
          <FormSelect
            className="col-4"
            value={tags}
            onChange={(options) => {
              let { query } = this.state;
              query.tags = options ? options.map((o) => o.value) : [];
              this.setState({ query }, this.request);
            }}
            placeholder="Tags"
            searchable
            multi
            options={Constants.TAGS.map((t) => ({ label: t, value: t }))}
          />
          <FormSelect
            className="col-4"
            value={authors}
            onChange={(options) => {
              let { query } = this.state;
              query.authors = options ? options.map((o) => o.value) : [];
              this.setState({ query }, this.request);
            }}
            placeholder="Authors name"
            searchable
            multi
            options={this.state.authors}
          />
          <FormInput
            containerClass="col-4"
            value={this.state.keywords}
            onChange={(text) => {
              let { query } = this.state;
              query.keywords = text;
              this.setState({ query });
            }}
            placeholder="Keywords"
          />
        </div>
      </div>
    );
  }
  render() {
    let results = this.props.resources.data.filter((i) =>
      testRegex(i.title, this.state.search)
    );
    return (
      <Page title="Master Library">
        <div className="row">
          <div className="col-2">
            <div className="btn-group" style={{ display: "block" }}>
              <button
                type="button"
                className="btn btn-block btn-light dropdown-toggle waves-effect waves-light"
                data-toggle="dropdown"
                aria-expanded="false"
              >
                Order by <span className="caret"></span>
              </button>
              <div className="dropdown-menu">
                {order_fields.map((item, index) => {
                  return (
                    <a
                      key={index}
                      className="dropdown-item"
                      href="#!"
                      onClick={(event) => {
                        event.preventDefault();
                        let { query } = this.state;
                        query.sort = item.value;
                        this.setState({ query }, this.request);
                      }}
                    >
                      <span
                        className={
                          this.state.query.sort === item.value
                            ? "text-info"
                            : "text-muted"
                        }
                      >
                        {item.label}
                      </span>
                    </a>
                  );
                })}
              </div>
            </div>
          </div>
          <div className="col-2">
            <div className="btn-group" style={{ display: "block" }}>
              <button
                type="button"
                onClick={() => {
                  this.setState({ showFilters: !this.state.showFilters });
                }}
                className="btn btn-block btn-light waves-effect waves-light"
              >
                Add filters
              </button>
              {this.state.showFilters && (
                <div className="dropdown-filters">{this.renderFilters()}</div>
              )}
            </div>
          </div>
          <SearchWithAction
            className="col-8"
            action="CREATE RESOURCE"
            onActionClick={() => this.props.push("/library/new")}
            onChange={(search) => this.setState({ search })}
          />
        </div>
        <CardBox>
          <Table
            id="libraries"
            renderEmpty={this.renderEmpty}
            columns={this.renderChild()}
            data={results}
          />
        </CardBox>
      </Page>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.authReducer.user,
  resources: state.resources,
});

const mapDispatchToProps = (dispatch) => ({
  retrieve(token, query) {
    dispatch(retrieve(token, query));
  },
  push(routeName) {
    dispatch(push(routeName));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(List);



// WEBPACK FOOTER //
// ./src/routers/Library/List.js